import { siteLocale } from './site-locale.js';

export function premiumBillingFormat(messages) {
    return {
        billingLine(billing = { state: 'unknown' }) {
            const state = billing?.state || 'unknown';
            const message = messages.billing[state] || messages.billing.unknown || '';
            const date = this.formatDate(state === 'cancellation_scheduled' ? billing?.cancellation_at : billing?.renewal_at);
            if (['automatic_renewal', 'invoice_renewal', 'cancellation_scheduled'].includes(state) && !date) {
                return messages.billing.unknown || '';
            }
            return message.replace('%date%', date);
        },
        /** A scheduled cancellation already states its end date, so an equal access date adds nothing. */
        repeatsEndDate(billing, date) {
            return billing?.state === 'cancellation_scheduled' && date !== '' && this.formatDate(billing.cancellation_at) === date;
        },
        // Billing dates use the UTC Gregorian day stated by the provider.
        formatDate(value) {
            if (!value) {
                return '';
            }

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return '';
            }

            return date.toLocaleDateString(siteLocale(), {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: 'UTC',
                calendar: 'gregory',
            });
        },
        formatAmount(amountMinor, currencyCode) {
            // Stripe charges ISK and UGX in hundredths despite their zero-decimal display convention.
            const zeroDecimal = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];
            const currency = currencyCode.toUpperCase();
            const threeDecimal = ['BHD', 'JOD', 'KWD', 'OMR', 'TND'];
            const divisor = zeroDecimal.includes(currency) ? 1 : (threeDecimal.includes(currency) ? 1000 : 100);
            const amount = amountMinor / divisor;
            return new Intl.NumberFormat(siteLocale(), { style: 'currency', currency, currencyDisplay: 'code' }).format(amount);
        },
        offerLabel(offer) {
            if (typeof offer.display_label === 'string' && offer.display_label.length > 0) {
                return offer.display_label;
            }
            const price = this.formatAmount(offer.unit_amount, offer.currency);
            return (offer.interval === 'month' ? messages.monthly : messages.annual).replace('%price%', price);
        },
    };
}
